import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { flexCenter } from '@/styles/layout';

export const EmailLinkBox = styled.div`
  width: 100%;
  background-color: ${COLORS.grey[150]};
  padding: 12px;
  border-radius: 8px;
  ${flexCenter};
`;
